<!--
 * @Author: mazhigang
 * @Date: 2023-07-01 19:16:24
 * @LastEditors: mazhigang
 * @LastEditTime: 2024-02-01 21:38:07
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>任务管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">违约列表</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="姓名">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.memberName"
                    placeholder="请输入违约人姓名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="手机号">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.memberPhone"
                    placeholder="请输入违约人手机号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="违约编号">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入违约编号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="任务编号">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.jobNo"
                    placeholder="请输入任务编号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="支付状态">
                  <el-select
                    style="margin-right: auto"
                    v-model="ruleForm.cadeVerifyStatus"
                    placeholder="请选择支付状态"
                  >
                    <el-option label="待支付" value="0"></el-option>
                    <el-option label="已支付" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="违约人类型">
                  <el-select
                    style="margin-right: auto"
                    v-model="ruleForm.memberType"
                    placeholder="请选择违约人类型"
                  >
                    <el-option label="客户" value="1"></el-option>
                    <el-option label="临勤" value="3"></el-option>
                    <el-option label="保安公司" value="4"></el-option>
                    <el-option label="保安公司员工" value="5"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <TableScrollSlider :table-ref="$refs.scrollTable" />
      <div class="pageTab">
        <el-table ref="scrollTable" :data="tableData" style="width: 100%">
          <el-table-column
            prop="violateLogNo"
            label="单号"
            align="center"
            width="190"
          >
          </el-table-column>
          <el-table-column
            prop="jobNo"
            label="任务编号"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="jobTitle"
            label="任务名称"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="memberName"
            label="违约人"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            width="120"
            prop="memberPhone"
            label="违约人手机号"
            align="center"
          >
          </el-table-column>
          <el-table-column label="违约人类型" align="center" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.memberType == 0">所有用户</span>
              <span v-if="scope.row.memberType == 1">客户</span>
              <span v-if="scope.row.memberType == 2">保安</span>
              <span v-if="scope.row.memberType == 3">临勤</span>
              <span v-if="scope.row.memberType == 4">保安公司</span>
              <span v-if="scope.row.memberType == 5">保安公司员工</span>
            </template>
          </el-table-column>
          <el-table-column prop="matterMemo" label="违约事项" align="center">
          </el-table-column>
          <el-table-column label="违约时间" align="center" width="180">
            <template slot-scope="scope">
              <span>{{ scope.row.violateAt }}</span>
            </template>
          </el-table-column>
          <el-table-column label="触发规则" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.withholdType == 2">￥</span>
              <span>{{ scope.row.withholdNum }}</span>
              <span v-if="scope.row.withholdType == 1">%</span>
            </template>
          </el-table-column>
          <el-table-column label="违约金额" align="center">
            <template slot-scope="scope">
              <span>￥{{ scope.row.actualPayAmount | moneyFormat }}</span>
            </template>
          </el-table-column>
          <el-table-column label="违约状态" align="center" width="120">
            <template slot-scope="scope">
              <span class="blueColor" v-if="scope.row.status == 0">待支付</span>
              <span class="greenColor" v-if="scope.row.status == 1"
                >已支付</span
              >
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right">
            <template slot-scope="scope">
              <div class="disAround">
                <div class="operateBtn" @click="goDetail(scope.row)">查看</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.taskData(),
      ruleForm: {
        name: "",
        jobNo: "",
        cadeVerifyStatus: "",
        memberName: "",
        memberPhone: "",
        memberType: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    goDetail(val) {
      this.$router.push({
        path: "/defaultDetail",
        query: {
          id: val.id,
        },
      });
    },
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.jobNo = "";
      this.ruleForm.cadeVerifyStatus = "";
      this.ruleForm.memberName = "";
      this.ruleForm.memberPhone = "";
      this.ruleForm.memberType = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        memberName: this.ruleForm.memberName,
        jobNo: this.ruleForm.jobNo,
        memberPhone: this.ruleForm.memberPhone,
        memberType: this.ruleForm.memberType,
        status: this.ruleForm.cadeVerifyStatus,
        violateLogNo: this.ruleForm.name,
      };
      this.$axios
        .post(`/admapi/violate/list`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style scoped>
.demo-ruleForm {
  width: 650px;
}
</style>
